<template>
    <div class="main">
        <h1 class="main-title pt-5">CONNEXION HIROPAY</h1>
        <div class="login-card">
            <form id="login" @submit.prevent="submit" ref="form">
                <fieldset id="inputs">
                    <input id="username" type="email" v-model="email" placeholder="Email" required />
                    <input id="password" type="password" v-model="password" class="mt-3" placeholder="Mot de passe" />
                </fieldset>
                <fieldset id="actions">
                    <v-btn type="submit" color="#C34500" class="white--text mb-3" style="width:170px;"
                        :loading="loading">Connexion</v-btn>
                    <p class="option" style="height: 50px; padding-top: 5px; "><span style="cursor:pointer;"
                            @click="reset">Mot de pass oubli&eacute;</span>&nbsp;&nbsp;| <span style="cursor:pointer;"
                            @click="$router.push('/register')">Inscription</span></p>
                </fieldset>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import firebase from '../fb'
export default {
    data() {
        return {
            email: '',
            password: '',
            loading: false,
            ip_address: ''
        }
    },
    mounted() {
        this.get_ip()
    },

    methods: {
        get_ip() {
            axios.get('https://httpbin.org/ip').then(response => {
                let { data } = response
                this.ip_address = data.origin
                console.log(data.origin);
            }).catch(err => {
                console.log(err);
            })
        },
        async submit() {
            let email = this.email
            email = email.replace(/\s/g, '');
            console.log(email);
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                console.log('hi');
                this.loading = true

                this.$store
                    .dispatch("authfb/login", {
                        email: email,
                        password: this.password,
                        ip_address: this.ip_address,
                        vm: this
                    })
                    .then(cred => {
                        setTimeout(() => {
                            this.loading = false
                            window.location.href = "/exchange";
                        }, 1000);
                    })
                    .catch(err => {
                        this.loading = false;
                        if (err.message == 'not verified') {
                            let { token } = err
                            swal("Email non vérifié", "Veillez vérifier votre email d'abord", "error", {
                                buttons: {
                                    cancel: "Annuler",
                                    verify: {
                                        text: "Renvoyer Email de Verification",
                                        value: "resend",
                                        closeModal: false,
                                    }
                                },
                                closeOnClickOutside: false
                            })
                                .then((value) => {
                                    let base_url = this.base_url
                                    if (location.hostname === "localhost") {
                                        base_url = 'http://localhost:4000'
                                    }
                                    let url = base_url + '/auth_pay/resend_verification'
                                    axios.post(url, {}, {
                                        headers: { Authorization: `Bearer ${token}` }
                                    }).then(response => {
                                        let { data } = response
                                        data == "success" ? swal("", "Email de verification envoyé avec succès", "success", { button: "ok" }) : swal("", "Erreur survenue veuillez ressayer ", "error", { button: "ok" })
                                    })
                                })
                        }
                    });
            } else {
                swal("Email mal écrit", " assurez vous que  votre email est bien écrit assurez vous qu'il n'y est pas d'espace au début ou à la fin!", "error", {
                    button: "ok"
                })

            }
        },

        reset() {
            swal({
                text: "Entrer Email",
                content: "input",
                button: {
                    text: "Réinitialiser",
                    closeModal: false
                }
            }).then(value => {

                //     swal("Erreur survenu!", "contactez le support et fournissez votre email pour assistance!", "error", {
                //     button: "ok"
                //   })

                var auth = firebase.auth();
                var emailAddress = value;
                auth.sendPasswordResetEmail(emailAddress).then(() => {
                    console.log('reset password sent');
                    this.load = false
                    swal("Lien de reinitialisation envoyé", "verifiez votre boite email pour changer votre mot de passe!", "success", {
                        button: "ok"
                    });

                }).catch(err => {
                    console.log(err.code);

                    if (err.code == 'auth/user-not-found') {
                        swal("Compte inexistant", "Veuillez soumettre un email enregistré sur HIROPAY !", "error", {
                            button: "ok!"
                        })
                        return
                    }

                    if (err.code == 'auth/invalid-email') {
                        swal("Erreur", "Email incorrect veuillez reessayer!", "error", {
                            button: "ok!"
                        })
                        return
                    }


                    swal("Erreur", "Erreur veuillez reessayer!", "error", {
                        button: "ok!"
                    })

                })
            })
        }
    },
    metaInfo: {
        title: 'Connexion | HIROPAY - Plateforme de Vente et Achat de Cryptomonnaies en Afrique de l\'Ouest',
        titleTemplate: '%s | HIROPAY',
        meta: [
            {
                name: 'description',
                content: 'Connectez-vous à votre compte HIROPAY, la plateforme sécurisée pour acheter et vendre des cryptomonnaies en Afrique de l\'Ouest, incluant des pays comme le Sénégal, la Côte d\'Ivoire, et le Mali.'
            },
            {
                name: 'keywords',
                content: 'HIROPAY, connexion, cryptomonnaie, vente et achat de cryptomonnaies, Afrique de l\'Ouest, plateforme de cryptomonnaie, Sénégal, Côte d\'Ivoire, Mali'
            },
            {
                property: 'og:title',
                content: 'Connexion | HIROPAY - Plateforme de Vente et Achat de Cryptomonnaies en Afrique de l\'Ouest'
            },
            {
                property: 'og:description',
                content: 'Accédez à votre compte HIROPAY pour acheter, vendre et gérer vos cryptomonnaies de manière sécurisée en Afrique de l\'Ouest, incluant des pays comme le Sénégal, la Côte d\'Ivoire, et le Mali.'
            },
            {
                property: 'og:url',
                content: 'https://hiropay.com/login'
            },
            {
                property: 'og:type',
                content: 'website'
            },
            {
                name: 'twitter:title',
                content: 'Connexion | HIROPAY'
            },
            {
                name: 'twitter:description',
                content: 'Connectez-vous à votre compte HIROPAY et gérez vos transactions de cryptomonnaies en toute sécurité en Afrique de l\'Ouest.'
            },
            {
                name: 'twitter:card',
                content: 'summary_large_image'
            }
        ]
    }
}
</script>

<style lang="scss" scoped>
.main {
    background: #283747 url("/img/login-bg.jpg") repeat top left;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.main-title {
    text-align: center;
    color: white;
    font-family: 'Teko', sans-serif !important;
    letter-spacing: 1px;
}

#login {
    /* box formulaire */

    margin: -175px 0 0 -240px;
    padding: 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 0;


}


h1 {
    text-transform: capitalize;
    text-align: right;
    margin: 0 0 30px 0;
    letter-spacing: 4px;
    font-size: 35px;
    letter-spacing: -0.06em;
}



fieldset {
    position: relative;
    border: 0;
    padding: 0;
    margin: 0;
    text-align: center;

}

fieldset#actions {
    display: block;
    height: 92px;
    overflow: hidden;
    position: relative;
}

fieldset#inputs {
    /* contour des inputs */
    padding: 10px;
    margin: 0px;
    width: 400px;


    box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.5) inset, 0 2px 2px 2px #1F1F1F inset;
    border-radius: 5px;
}

@media screen and (-webkit-animation) {
    fieldset#inputs:before {
        width: 440px !important;
    }
}

fieldset#inputs:before {
    /* couture autour des inputs */
    content: "";
    padding: 0px;
    margin: -18px -22px;
    width: 435px;
    height: 145px;
    position: absolute;
    border-radius: 2px;
    z-index: -1;
}

#inputs input {
    /* pictos des inputs */
    background: #f1f1f1;
    padding: 10px 10px 10px 15px;
    margin: 0 0 10px 5px;
    width: 85%;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 1px 1px #525252 inset, 0 1px 0 #6A6A6A;
}

#username {
    background-position: 5px -2px !important;
}

#password {
    background-position: 5px -52px !important;
}

#inputs input:focus {
    background-color: #fff;
    border-color: #e8c291;
    outline: none;
    box-shadow: 0 0 0 1px #e8c291 inset;
}

/*--------------------*/
#actions {
    margin: 25px 0 0 0;
}

#submit {
    /* bouton de connection */
    background-color: #ffb94b;
    background-image: linear-gradient(top, #C94700, #B84100);
    border-radius: 2px;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.7);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 17px 2px rgba(255, 255, 255, 0.2) inset, 0 5px 5px rgba(255, 255, 255, 0.2) inset;
    display: block;
    border: none;
    position: relative;
    float: none;
    height: 35px;
    padding: 0;
    margin: 0 auto 20px;
    width: 120px;
    cursor: pointer;
    font-size: 18px;
    color: #FFF;
    text-transform: capitalize;
}

#submit:hover,
#submit:focus {
    background-color: #C94700;
    background-image: linear-gradient(top, #B84100, #C94700);
}

#submit:active {
    outline: none;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5) inset;
}

#submit::-moz-focus-inner {
    border: none;
}

#actions a {
    color: #000000;
    float: none;
    line-height: 35px;
    margin-left: 10px;
    text-decoration: none;
}

#actions a:hover {
    color: #FFFFFF;
    text-decoration: underline;
}

.option {
    margin: auto;
    width: 250px;
    background-color: #C8BCB6;
    border-radius: 5px;
}

.option:after {
    content: "";
    width: 260px;
    height: 40px;
    left: 78px;
    top: 50px;
    position: absolute;

    border-bottom: none;
    border-radius: 2px;
    z-index: -1;
}

.apple,
.butt:before,
.top span:after,
.butt:after,
.top:before,
.top:after,
.butt:before,
.butt:after {
    background: #FFF;
    /* foreground color */
}

.bite,
.butt span,
.butt,
.top,
.top span {
    background: #DE6625;
    /* background color */
}

.apple {
    width: 25.06px;
    height: 22.2px;
    border-radius: 36% 36% 41% 41% / 42% 42% 75% 75%;
    position: absolute;
    margin: 0px;
    right: -22px;
    top: 92px;
    z-index: 100;
}

.bite {
    position: absolute;
    width: 60%;
    height: 62%;
    right: -40%;
    top: 8%;
    border-radius: 60%;
}

.butt span {
    display: block;
    position: absolute;
    border-radius: 100% 100% 0% 0%;
    width: 24.5%;
    height: 400%;
    bottom: -239%;
    left: 38%;
}

.butt {
    position: absolute;
    width: 100%;
    height: 4%;
    bottom: -1%;
}

.butt:before {
    content: '';
    position: absolute;
    width: 24%;
    height: 400%;
    border-radius: 0% 0% 100% 100%;
    left: 21%;
    bottom: 38%;
}

.butt:after {
    content: '';
    position: absolute;
    width: 23.4%;
    height: 400%;
    border-radius: 0% 0% 100% 100%;
    right: 21%;
    bottom: 38%;
}


.top span {
    display: block;
    position: absolute;
    border-radius: 0 0 44% 44% / 0 0 100% 100%;
    width: 63%;
    height: 259%;
    top: -92%;
    left: 18.6%;
    z-index: 3;
}

.top span:after {
    border-radius: 100% 0 100% 0;
    content: "";
    height: 242%;
    left: 41%;
    position: absolute;
    top: -193%;
    width: 90%;
}

.top {
    position: absolute;
    width: 42%;
    height: 4%;
    top: 0px;
    left: 29%;
}

.top:before {
    content: '';
    position: absolute;
    width: 62%;
    height: 260%;
    border-radius: 100% 100% 0% 0% / 100% 200% 0% 0%;
    left: -27%;
    top: 1%;
}

.top:after {
    content: '';
    position: absolute;
    width: 62%;
    height: 260%;
    border-radius: 100% 100% 0% 0% / 200% 100% 0% 0%;
    right: -27%;
    top: 1%;
}
</style>